module.exports = __webpack_public_path__ + "img/image05.82c9240f.jpg";